// Module
var code = "<div id=\"create-s-form\" ng-class=\"$ctrl.screen\" ng-transclude></div>";
// Exports
module.exports = code;